import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VafPaymentCardComponent } from './vaf-payment-card.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxFileDropModule } from 'ngx-file-drop';
import { IonicSelectableComponent } from 'ionic-selectable';
import { NgxMatDateFormats, NgxMatDatetimePickerModule, NgxMatTimepickerModule, NGX_MAT_DATE_FORMATS } from '@angular-material-components/datetime-picker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { getDateFormat, getDateTimeFormat} from 'src/app/services/mfeApp.service';

@NgModule({
  declarations: [VafPaymentCardComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReactiveFormsModule,
    NgxFileDropModule,
    IonicSelectableComponent,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatMomentModule,
    MatDatepickerModule],
  exports: [
    VafPaymentCardComponent
  ],
  providers: [
    { provide: NGX_MAT_DATE_FORMATS, useValue: getDateTimeFormat() }
  ]
})
export class VafPaymentCardComponentModule { }